<div class="container" [formGroup]="newsletterTemplateEditFormGroup">
    <mat-card appearance="outlined" class="mat-component-background mat-elevation-z2">
        <mat-card-header>
            <mat-card-title> Edit Newsletter Template </mat-card-title>
        </mat-card-header>
        <mat-card-content class="container-card">
            <div [ngClass]="{
                'container-content-xlarge': isXLarge(),
                'container-content-large': isLarge(),
                'container-content-medium': isMedium(),
                'container-content-small': isSmall(),
                'container-content-xsmall': isXSmall()
            }">
                <form [formGroup]="newsletterTemplateEditFormGroup">
                    <div class="container-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input matInput placeholder="Ex. My newsletter template" formControlName="name" />
                            <mat-error *ngIf="
                    newsletterTemplateEditFormGroup.get('name').hasError('required') &&
                    newsletterTemplateEditFormGroup.get('name').touched
                  ">
                                <span>Name is required</span>
                            </mat-error>
                            <mat-error *ngIf="
                    newsletterTemplateEditFormGroup.get('name').hasError('minlength') &&
                    newsletterTemplateEditFormGroup.get('name').touched
                  ">
                                <span>Name should have a minimum length of
                                    {{ minNameLength }}</span>
                            </mat-error>
                            <mat-error *ngIf="
                    newsletterTemplateEditFormGroup.get('name').hasError('maxlength') &&
                    newsletterTemplateEditFormGroup.get('name').touched
                  ">
                                <span>Name can have a maximum length of
                                    {{ maxNameLength }}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </mat-card-content>
    </mat-card>
    <div id="gjs" #gjs></div>
</div>